module.exports = __webpack_public_path__ + "img/indextop.43132092.gif";